import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { NotificationDTO } from '../models/NotificationDTO.model';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private httpService: HttpService) { }

  createNotification(notification: NotificationDTO) {
    return this.httpService.createNotification(notification).pipe(
      tap((data) => {
      })
    );
  } 

  getNotification() {
    return this.httpService.getNotification().pipe(
      tap((data) => {
      })
    );
  }
}
